export default __webpack_public_path__ + "static/media/Sanskirt.1196fd90.webp";